/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Theme controller
 */
export default class extends Controller {
  static targets = ['section'];

  /**
   * GSAP context.
   */
  ctx = null;

  /**
   * Connect the Controller.
   */
  connect() {
    if (this.hasSectionTarget) {
      this.ctx = gsap.context(() => {
        this.sectionTargets.forEach((section) => {
          const { theme, offset } = section.dataset;

          ScrollTrigger.create({
            trigger: section,
            start: 'top 1',
            end: offset !== undefined
              ? () => `bottom+=${window.innerHeight} top`
              : 'bottom top',
            toggleClass: {
              targets: document.documentElement,
              className: `theme-${theme}`,
            },
          });
        });
      });
    }
  }

  /**
   * Disconnect the controller.
   */
  disconnect() {
    if (this.ctx) {
      this.ctx.revert();
    }
  }
}
